import React, { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import axios from "axios";
import { loginRequest } from "../../Middleware/auth";

import { 
  Box, 
  Card, 
  CardContent, 
  CircularProgress, 
  Container, 
  Typography 
} from '@mui/material';
import { COLORS } from "../../Styles/Colors";
import { RiMicrosoftLine } from "react-icons/ri";
import MicrosoftIcon from "../Icons/MicrosoftIcon";
import styled from "styled-components";


const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  width: 100%;
  padding: 0.6rem 0.8rem;
  margin-top: 1.5rem;

  background-color: ${COLORS.teal};
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1.1rem;
  font-weight: 500;
  transition: background-color 0.2s ease;



  &:hover {
    background-color: ${COLORS.darkTeal};
  }

  &:disabled {
    background-color: ${COLORS.gray};
    cursor: not-allowed;
  }
`;


function MsalConfig() {
  const { instance, accounts } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest);
  };

  // useEffect(() => {
  //   const handleRedirect = async () => {
  //     try {
  //       const response = await instance.handleRedirectPromise();
  //       if (response) {

  //         const idToken = response.idToken;
  //         const email = response.account.username;

  //         // Send the token to your backend
  //         // const res = await axios.post("http://localhost:4000/auth/microsoft", {
  //         //   idToken, // this will be validated server-side
  //         //   email,   // optional, can help backend map users
  //         // });

  //         // Store it in localStorage, context, etc.
  //       }
  //     } catch (e) {
  //       console.error("Redirect handling error", e);
  //     }
  //   };

  //   handleRedirect();
  // }, [instance]);

  return (


   <Button
    onClick={handleLogin}
    type="button"
  >
 
   <MicrosoftIcon /> Microsoft
  </Button>

    
  );
}

export default MsalConfig;
